import { useState } from 'react';
import Swal from 'sweetalert2';
import { getAllArticuloPrecio, importArticuloPrecio } from '../../../Services/articuloPrecioService';
import { listaPreciosExcel } from '../../../Services/reporteService';

const usePriceList = () => {
  const [file, setFile] = useState()
  const [isLoading, setIsLoading] = useState(false)

  //export:
  const handleExport = async (listaId) => {
    try {
      const priceLists = await getAllArticuloPrecio(true, 0, listaId, '', 50000)
      const excel = await listaPreciosExcel(priceLists.data.content, null)
      const byteCharacters = atob(excel.data)
      const byteNumbers = new Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'priceLists.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Export error:', error)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al generar el archivo.',
        showConfirmButton: true,
      })
    }
  }

  //import:
  const handleImport = (e) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('file', file)

    setIsLoading(true)
    importArticuloPrecio(formData)
      .then(() => {
        Swal.fire({
          title: 'Importación exitosa',
          text: 'La lista de precios se importó correctamente.',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
        })
      })
      .catch(() => {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo importar la lista de precios. Verifique los datos del archivo.',
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
        })
      })
      .finally(() => setIsLoading(false))
  }

  return {
    file,
    setFile,
    isLoading,
    handleImport,
    handleExport,
  }

}

export default usePriceList